import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SizeInformer from '~/views/Home/base/SizeInformer';
import autoFontSize from 'afontsize';
import isEqual from 'lodash.isequal';
import debounce from 'lodash.debounce';
import CellScores from './scores/CellScores';
import getLeaderboardResFactor from '../../../../../utils/getLeaderboardResFactor';

const NAME_FONT_SIZE_INITIAL = 12;

const MIN_SCORE_FONT_SIZE = 10;
const MAX_SCORE_FONT_SIZE = 24;

const BREAKPOINT_SCORES_BELLOW = 975;
const BREAKPOINT_PHONE = 624;

export default
class ScoredSizeFinder extends Component {
    static propTypes = {
        i: PropTypes.number.isRequired,
        testData: PropTypes.object.isRequired,
        columns: PropTypes.object.isRequired,
        labelsCount: PropTypes.number.isRequired,
        roundConfig: PropTypes.object.isRequired,
        deviceType: PropTypes.string.isRequired
    }

    state = {
        className: '',
        scoreFontSize: 0,
        scoreWidth: 0,
        nameFontSize: NAME_FONT_SIZE_INITIAL,
        nameWidth: 0,
        lastUpdate: new Date(0)
    }

    componentWillUnmount() {
        this.scoresContainer = null;
        this.nameFontSizer = null;
        this.mainContainer = null;
        this.rankLabel = null;
        this.scoreLabel = null;
        this.scoreFontSizer = null;
    }

    calculateSizes = debounce(({ width: scoresMaxWidth  }) => {
        if (
            !this.scoreLabel
            || !this.rankLabel
            || !this.mainContainer
            || !this.scoresContainer
            || !this.scoreFontSizer
            || !this.nameFontSizer
        ) {
            return;
        }

        const {
            labelsCount,
            deviceType,
            listWidth,
            tableWidth,
            roundConfig: {
                mostRunsCount,
                mostTricksCount
            }
        } = this.props;

        const { clientHeight: labelHeight } = this.scoreLabel;
        const { clientWidth: mainContainerWidth } = this.mainContainer;

        const scoresCount = mostRunsCount + mostTricksCount;

        const resFactor = getLeaderboardResFactor(scoresCount);
        const width = Math.floor(
            (
                resFactor ? ((tableWidth - mainContainerWidth) * resFactor) : scoresMaxWidth
                // - scoresCount
                // - mainContainerWidth
                // - rankWidth
                - (labelHeight * labelsCount)
            ) / (scoresCount)
        );

        this.scoreFontSizer.style.width = `${width}px`;

        let scoreFontSize = autoFontSize(
            this.scoreFontSizer,
            {
                min: MIN_SCORE_FONT_SIZE,
                max: MAX_SCORE_FONT_SIZE
            }
        );

        if (listWidth < BREAKPOINT_SCORES_BELLOW) {
            scoreFontSize = MIN_SCORE_FONT_SIZE;
        }

        this.scoreFontSizer.style.width = 'auto';

        const nameFontSize = scoreFontSize;
        this.nameFontSizer.style.fontSize = `${nameFontSize}px`;

        let className = (
            (
                deviceType === 'phone'
                || deviceType === 'tablet'
            )
            && listWidth < BREAKPOINT_SCORES_BELLOW
            && scoreFontSize === MIN_SCORE_FONT_SIZE
            && scoresMaxWidth < this.scoresContainer.clientWidth
        )
            ? 'show-scores-bellow'
            : ''
        ;

        if (listWidth < BREAKPOINT_PHONE) {
            className += ' phone';
        }

        const nameWidth = this.nameFontSizer.clientWidth;

        this.setState({
            className,
            scoreFontSize,
            scoreWidth: this.scoreFontSizer.clientWidth,
            nameFontSize,
            nameWidth,
        });
    }, 40)

    getSnapshotBeforeUpdate(prevProps) {
        if (Object.keys(prevProps).length !== Object.keys(this.props).length) {
            this.setState({
                lastUpdate: new Date()
            });

            return true;
        }

        let paramsChanged = false;

        for (let key in this.props) {
            if (key === 'children') {
                continue;
            }

            paramsChanged = paramsChanged || !isEqual(
                this.props[key],
                prevProps[key]
            );
        }

        if (paramsChanged) {
            this.setState({
                lastUpdate: new Date()
            });
        }

        return paramsChanged;
    }

    loaded = false

    componentDidUpdate() {
        if (this.loaded) {
            return;
        }

        setTimeout(() => {
            this.setState({
                lastUpdate: new Date()
            });
        }, 100);

        this.loaded = true;
    }

    render() {
        const {
            i,
            columns,
            testData: {
                longestAthleteName,
                longestScore,
                testAthlete
            },
            roundConfig,
            children
        } = this.props;

        const {
            className,
            nameFontSize,
            scoreFontSize,
            scoreWidth,
            nameWidth,
            lastUpdate,
        } = this.state;

        const scoreStyle = {
            fontSize: scoreFontSize,
            width: scoreWidth
        };

        return [
            <div
                key={`leaderboard_scored_group_size_finder_${i}`}
                className="size-finder"
            >
                <div className="row row-scored sizer-row">
                    <span className="score-label">
                        <span
                            ref={ref => this.scoreLabel = ref}
                            className="rotated"
                        >
                            Total
                        </span>
                    </span>

                    <div className="needs">
                        <div className="score-item">
                            <span
                                ref={ref => this.rankLabel = ref}
                                className="rank"
                            >
                                1st
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row row-scored sizer-row">
                    <span
                        ref={ref => this.scoreFontSizer = ref}
                        className="score-item"
                    >
                        {longestScore}
                    </span>
                </div>

                <div className="row row-scored sizer-row">
                    <div
                        ref={ref => this.mainContainer = ref}
                        className="holder-main"
                    >
                        <div className="cell cell-no">
                            00
                        </div>

                        {columns.Bib &&
                            <div className="cell cell-bib">
                                10
                            </div>
                        }

                        <div className="cell cell-name">
                            <div
                                ref={ref => this.nameFontSizer = ref}
                                style={{ fontSize: nameFontSize }}
                            >
                                {longestAthleteName}
                                {columns.Nation &&
                                <div className="nation">
                                    WWW
                                </div>
                                }
                            </div>
                        </div>
                    </div>

                    <SizeInformer
                        className="holder-scores"
                        onResized={this.calculateSizes}
                        lastUpdate={lastUpdate}
                    >
                        <CellScores
                            onRef={ref => this.scoresContainer = ref}
                            style={{ flexGrow: 0 }}
                            scoreStyle={scoreStyle}
                            roundConfig={roundConfig}
                            colors={{
                                scores: {}
                            }}
                            data={{ value: longestScore }}
                            t={() => '1st'}
                            athlete={testAthlete}
                            showJudgeScoresPopup={false}
                        />
                    </SizeInformer>
                </div>
            </div>,

            children({
                className,
                noStyle: {
                    fontSize: scoreFontSize
                },
                nameStyle: {
                    fontSize: nameFontSize,
                    width: nameWidth,
                    // minWidth: nameWidth,
                },
                scoreStyle
            })
        ];
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/SizeFinder.js